/** Domains whose accounts must sign in with Microsoft 365. */
export const DEFAULT_INTERNAL_EMAIL_DOMAINS = ['k-rev.com'];
export function emailDomain(email) {
    return email.slice(email.lastIndexOf('@') + 1).toLowerCase();
}
export function expectedSignInMethod(email, internalDomains) {
    return internalDomains.includes(emailDomain(email)) ? 'microsoft' : 'password';
}
/** Prefix of the tokens accepted in development mode. */
export const DEVELOPMENT_TOKEN_PREFIX = 'dev:';
//# sourceMappingURL=auth-contracts.js.map